import React, {Component} from "react";
import PropTypes from 'prop-types';

import {XButton, XDiv} from "../Layout/Layout";
import Flow from "../Loading/Flow";
import {FormManagerContext} from "./FormManagerContext";

class Submit extends Component{

    constructor(props) {
        super(props);
        this.props=props;
    }

    render() {
        const {
            children,
            className,
        } = this.props;

        let fmState = this.context;

        let process=null;
        if (fmState.isProcess) {
            process=<XDiv   className="inline-loader"  >
                        <Flow   />
                    </XDiv>;
        }

        return  <XButton type="submit" className={className}   >
            {children}
            {process}
        </XButton>;
    }
}


Submit.propTypes = {
    className: PropTypes.string,
};

Submit.defaultProps = {
    className:"btn  btn-success"
};

Submit.contextType = FormManagerContext;

export default Submit;

